import { ReactNode } from 'react';
import Markdown from '../markdown.tsx';

export const shuffleArray = (array: number[]): number[] => {
  const shuffledArray = [...array];
  const randomSort = () => Math.random() - 0.5;
  shuffledArray.sort(randomSort);
  return shuffledArray;
};

export const createQuestionNameForQuiz = (id: number): ReactNode => {
  return <span>{`QID: ${id}`}</span>;
};

export const createExpandedQuestionNameForQuiz = (
  id: number,
  content: string | null | undefined,
  prompt: string | null | undefined,
): ReactNode => {
  return (
    <div className={'flex min-w-0 flex-col gap-3'}>
      <div>{`QID: ${id}`}</div>
      {content && (
        <div className={'min-w-0'}>
          <Markdown>{content}</Markdown>
        </div>
      )}
      {prompt && (
        <div className={'min-w-0'}>
          <Markdown>{prompt}</Markdown>
        </div>
      )}
    </div>
  );
};
